/*
 * @Author: zxf
 * @Date: 2022-07-20 14:20:09
 * @LastEditors: DQL
 * @LastEditTime: 2022-10-24 18:57:14
 * @Description: 维保检测路由
 */
const xmglRoutes = {
  path: 'bggl',
  name: 'xfjcbggl',
  component: { template: '<router-view></router-view>' },
  children: [
    {
      path: 'all',
      name: 'sybg',
      component: () => import(/* webpackChunkName: "xfjcsybg" */'@/features/xfjcgl/bggl/index.vue'),
      meta: {
        navtabTitle: '所有报告',
        isCache: true,
        ignoreDiff: [],
        menuElements: [
          { elementCode: 'jcsybg_search', elementName: '查询' },
          { elementCode: 'jcxm_scbg_ls', elementName: '生成临时报告' },
          { elementCode: 'jcxm_scbg', elementName: '生成报告' },
          { elementCode: 'jcxm_cxjc', elementName: '重新检测' },
          { elementCode: 'jcxm_sqxg', elementName: '申请修改' },
          { elementCode: 'jcxm_qz', elementName: '签章' },
          { elementCode: 'jcxm_gz', elementName: '盖章' }
        ]
      }
    },
    {
      path: 'dscbg',
      name: 'dsc',
      component: () => import(/* webpackChunkName: "xfjcdsc" */'@/features/xfjcgl/bggl/index.vue'),
      meta: {
        navtabTitle: '待生成报告',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    },
    {
      path: 'dqz',
      name: 'dqz',
      component: () => import(/* webpackChunkName: "xfjcdqz" */'@/features/xfjcgl/bggl/index.vue'),
      meta: {
        navtabTitle: '待签章',
        isCache: true,
        ignoreDiff: []
      }
    },
    {
      path: 'yqz',
      name: 'yqz',
      component: () => import(/* webpackChunkName: "xfjcdqz" */'@/features/xfjcgl/bggl/index.vue'),
      meta: {
        navtabTitle: '已签章',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    },
    {
      path: 'dgz',
      name: 'dgz',
      component: () => import(/* webpackChunkName: "xfjcdgz" */'@/features/xfjcgl/bggl/index.vue'),
      meta: {
        navtabTitle: '待盖章',
        isCache: true,
        ignoreDiff: [],
        menuElements: [
          { elementCode: 'jcxm_gz', elementName: '盖章' }
        ]
      }
    },
    {
      path: 'ygz',
      name: 'ygz',
      component: () => import(/* webpackChunkName: "xfjcdgz" */'@/features/xfjcgl/bggl/index.vue'),
      meta: {
        navtabTitle: '已盖章',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    },
    {
      path: 'yfb',
      name: 'yfb',
      component: () => import(/* webpackChunkName: "xfjcygz" */'@/features/xfjcgl/bggl/index.vue'),
      meta: {
        navtabTitle: '已发布',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    },
    {
      path: 'yzf',
      name: 'yzf',
      component: () => import(/* webpackChunkName: "xfjcbgYzf" */'@/features/xfjcgl/bggl/index.vue'),
      meta: {
        navtabTitle: '已作废',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    }
  ]
};

export default xmglRoutes;
